const serviceJobNoteTypes = {
  studio: {
     id: 1,
     name: 'Studio',
     description: 'Studio',
  },
  provider: {
    id: 2,
    name: 'Provider',
    description: 'Provider',
  },
  totalAssetNote: {
    id: 3,
    name: 'TotalAssetNote',
    description: 'TotalAssetNote',
  },
  shootListNote: {
    id: 4,
    name: 'ShootListNote',
    description: 'ShootListNote',
  },
  clientBookingNote: {
    id: 5,
    name: 'ClientBookingNote',
    description: 'ClientBookingNote',
  },
}

export default serviceJobNoteTypes
